// extracted by mini-css-extract-plugin
export default {"cardLegend":"OverviewCardLegend_cardLegend__xksBo","detailsItem":"OverviewCardLegend_detailsItem__2774I","wrapped":"OverviewCardLegend_wrapped__QpTpM"};